

function ErrorPage() {
    return (<>
        <div class="error-page" style={{ minHeight: 0 }}>

            <div class="error-page-content">
                <div class="error-code">404</div>
                <h1>Oops!</h1>
                <h3>죄송합니다. 로그인 권한이 없습니다.</h3>
                <hr class="opacity-1" />

                <a href="http://www.bearworld.co.kr/share/page/user-portal-main" class="btn btn-theme px-3 rounded-pill"><i class="fa fa-arrow-left me-1 ms-n1"></i> 베어월드 메인페이지로 이동</a>
            </div>

        </div>
    </>);
}

export default ErrorPage;